import React, { useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

import { Modal } from "../modal";

type Props = Readonly<{
  open: boolean;
  toggleModal: (v: boolean) => void;
  _src?: string;
  media: { type: "video" | "photo"; src: string; media_url: string }[] | null;
  initialIdx?: number;
}>;

export const LightBox: React.FC<Props> = ({
  open,
  toggleModal,
  _src,
  initialIdx = 0,
  media,
}) => {
  const [visibleMediaIdx, updateVisibleMediaIdx] = useState(initialIdx);

  useEffect(() => {
    updateVisibleMediaIdx(initialIdx);
  }, [initialIdx]);

  if (!media) return <></>;

  const showArrows = media?.length > 1;

  const onArrowClick = (direction: string) => () => {
    const photosLength = media?.length;
    let resultedIdx = visibleMediaIdx;
    if (direction === "left") {
      if (visibleMediaIdx === 0) {
        resultedIdx = photosLength - 1;
      } else {
        resultedIdx -= 1;
      }
    }
    if (direction === "right") {
      if (visibleMediaIdx === photosLength - 1) {
        resultedIdx = 0;
      } else {
        resultedIdx += 1;
      }
    }

    updateVisibleMediaIdx(resultedIdx);
  };

  // @ts-ignore
  return (
    <Modal open={open} toggleModal={toggleModal} noBackground>
      {showArrows && (
        <ChevronLeftIcon
          className="absolute w-10 h-10 cursor-pointer text-white top-1/2 -left-20 -translate-y-1/2"
          onClick={onArrowClick("left")}
        />
      )}

      <div className="h-full max-h-[95vh] max-w-screen-sm w-full flex items-center justify-center">
        {media?.[visibleMediaIdx] ? (
          media[visibleMediaIdx]?.type === "photo" ? (
            <img
              className="h-full w-full object-contain"
              src={media[visibleMediaIdx].media_url}
              alt="alert"
              key={media[visibleMediaIdx].media_url}
            />
          ) : (
            <video
              key={media[visibleMediaIdx].media_url}
              width="320"
              height="240"
              controls
              autoPlay
              className="my-auto w-full object-contain"
            >
              <source src={media[visibleMediaIdx].media_url} type="video/mp4" />
              <source src={media[visibleMediaIdx].media_url} type="video/ogg" />
              Ваш браузер не поддерживает воспроизведение видео.
            </video>
          )
        ) : null}
      </div>

      {showArrows && (
        <ChevronRightIcon
          className="absolute w-10 h-10 cursor-pointer text-white top-1/2 -right-20 -translate-y-1/2"
          onClick={onArrowClick("right")}
        />
      )}
    </Modal>
  );
};
